import { IOrder } from '../../interface/IOrder.ts';

const toBool = (value:any) => value === '1' || value === 1 || value === true;

export const orderToFormData = (order:IOrder) => {
    let participation = '';
    if (toBool(order.participation_second_repeat)) {
        participation = 'participation_second_repeat';
    } else if (toBool(order.participation_repeat)) {
        participation = 'participation_repeat';
    } else if (toBool(order.participation_first_attempt)) {
        participation = 'participation_first_attempt';
    }

    return {
        exam_type_efa_cfp: toBool(order.exam_type_efa_cfp),
        exam_type_din_competence: toBool(order.exam_type_din_competence),
        exam_type_cga_cfep: toBool(order.exam_type_cga_cfep),
        participation,
        education_program: order.education_program != null ? String(order.education_program) : '',
        certificate_proof: order.certificate_proof || '',
        accept_exam_regulations: toBool(order.accept_exam_regulations),
        accept_agb: toBool(order.accept_agb),
        accept_privacy: toBool(order.accept_privacy),
        accept_withdrawal: toBool(order.accept_withdrawal),
        request_early_check: toBool(order.request_early_check),
    };
};
